import {  NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { LicenseComponent } from './license/license.component';
import { RouterModule, Routes } from '@angular/router';
import { BlockUIModule } from 'ng-block-ui';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BBSFControlsModule } from 'bbsf-controls';
import { ClipboardModule } from 'ngx-clipboard';
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { InlineSVGModule } from 'ng-inline-svg';
import { AuthService, BBSFTranslateService, EnvironmentService, UtilityService } from 'bbsf-utilities';
import { LicenseService } from '../shared/Services/LicenseService.service';

const routes: Routes = [
  {
    path: '', component: LicenseComponent
  }
]
@NgModule({
  declarations: [LicenseComponent],
  imports: [
    CommonModule,
    ClipboardModule,
    BlockUIModule.forRoot(),
    RouterModule.forChild(routes),
    ReactiveFormsModule,
    FormsModule,
    BBSFControlsModule,
    NgbModule,
    InlineSVGModule

  ],
  providers:[
    EnvironmentService,
    UtilityService,
    AuthService,
    BBSFTranslateService,
    DatePipe,
    LicenseService


  ]
})
export class LicenseModule { }
